import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d0621ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "iframe-container"
}
const _hoisted_2 = {
  name: "my-frame",
  width: "100%",
  height: "auto",
  ref: "myIframe",
  scrolling: "no"
}
const _hoisted_3 = {
  key: 1,
  class: "margin-top-2-em"
}
const _hoisted_4 = {
  key: 2,
  id: "loadXmlDialog",
  class: "dialog showLoadXmlWithLocalStorage mt-5"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "govuk-form-group column-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "govuk-label",
  for: "load-file"
}, "Načítať zo súboru", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "govuk-form-group column-full mt-5" }
const _hoisted_10 = { class: "mt-5 ml-5" }
const _hoisted_11 = {
  key: 0,
  class: "ml-15"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "List of uploaded files:", -1))
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = {
  key: 1,
  class: "ml-15 mb-5"
}
const _hoisted_15 = { class: "text-center ma-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "mt-10 mr-5 ml-5 mb-10" }, {
      content: _withCtx(() => [
        (_ctx.origin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("iframe", _hoisted_2, null, 512)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.showXmlDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateForm())),
                class: "govuk-button govuk-margin-right-1"
              }, " Skontrolovať "),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitForm(this.$route.params.id))),
                class: "govuk-button govuk-margin-right-1"
              }, " Odoslať "),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog())),
                class: "govuk-button govuk-margin-right-1"
              }, " Načítať z XML "),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadXml())),
                class: "govuk-button govuk-margin-right-1"
              }, " Uložiť XML ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.showXmlDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                "data-module": "govuk-button",
                class: "govuk-button",
                style: {"margin-bottom":"12px"},
                type: "button",
                id: "hide-load-dialog",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideXmlDialog()))
              }, " Skryť "),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("input", {
                    type: "file",
                    name: "load-file",
                    id: "load-file",
                    class: "govuk-file-upload",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLoadXml && _ctx.handleLoadXml(...args)))
                  }, null, 32)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    "data-module": "govuk-button",
                    class: "govuk-button",
                    type: "button",
                    id: "load-btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadXml()))
                  }, " Načítať ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, { class: "mt-10 mr-5 ml-5 mb-10" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_10, _toDisplayString(this.$t("attachments")), 1),
        _createVNode(_component_v_file_input, {
          label: "File input",
          class: "custom-input-field ml-5",
          accept: _ctx.allowedFileTypes,
          onChange: _ctx.handleFileUpload
        }, null, 8, ["accept", "onChange"]),
        (_ctx.uploadedFiles.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedFiles, (file) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: file.name,
                    class: "no-marker"
                  }, [
                    _createTextVNode(_toDisplayString(file.name) + " ", 1),
                    _createVNode(_component_v_icon, {
                      onClick: ($event: any) => (_ctx.handleDeleteFile(file.id)),
                      class: "text-red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close-circle ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(this.$t("noFilesUploaded")), 1)
            ]))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbar,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.snackbar) = $event)),
        timeout: _ctx.timeout
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "red",
            variant: "text",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.snackbar = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Close ")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.text) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "timeout"])
    ])
  ], 64))
}